module.exports = __webpack_public_path__ + "static/media/spotify.9cc17d1b.png";